import script from "./Feedback.vue?vue&type=script&setup=true&lang=js"
export * from "./Feedback.vue?vue&type=script&setup=true&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=459594e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-459594e8"]])

export default __exports__